import React from "react";
import styled from "styled-components";

const ActivitySummery = ({ startingPoint, minBooking, duration, nextAvailable }) => {
  return (
    <Container>
      <Wrapper>
        <Header title={startingPoint}>
          <Label>Start: </Label>
          {startingPoint}
        </Header>
        <Header right title={minBooking}>
          <Label>Min. members: </Label>
          {minBooking}
        </Header>
      </Wrapper>
      <Wrapper>
        <Header title={duration}>
          <Label>Duration: </Label>
          {duration}
        </Header>
        <Header right title={nextAvailable}>
          <Label>Next: </Label>
          {nextAvailable}
        </Header>
      </Wrapper>
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Header = styled.h4`
  flex-basis: 50%;
  margin: 0;
  font-size: 0.8rem;
  line-height: calc(0.7rem * 1.25 * 1.25);
  overflow: hidden;
  font-weight: 500;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: ${props => (props.right ? "right" : "left")};
  color: #484848;
`;

const Label = styled.span`
  margin: 0;
  font-size: 0.8rem;
  overflow: hidden;
  font-weight: 400;
`;

export default ActivitySummery;
